import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueCompanyPageBrands } from '../../../types/companyDetail';
import { CompanyDetailBrandsChild } from '../../molecules/companyDetailBrandsChild';

type Props = {
  brandIds: number[];
  coverNoImg: string;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageBrands;
};

export const Presentation: FunctionComponent<Props> = ({
  brandIds,
  coverNoImg,
  dataCategory,
  dataValue,
}) => {
  if (!brandIds || brandIds.length === 0) return null;

  return (
    <section className="company__page__recruitments css-slider" id="brands">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">
          ブランド
        </h2>
      </div>
      <div className="company__page__recruitments__wrapper slides">
        {brandIds.map((id) => (
          <CompanyDetailBrandsChild
            key={id}
            id={id}
            coverNoImg={coverNoImg}
            dataCategory={dataCategory}
            dataValue={dataValue}
          />
        ))}
      </div>
    </section>
  );
};
